import React from "react";
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import type { StepIconProps } from "@mui/material/StepIcon";

const StepperIcon: React.FC<StepIconProps & { variant?: 'main' | 'sub'; icon: React.ReactElement }> = ({ 
  active, 
  completed, 
  icon, 
  variant = 'main' 
}) => {
  const size = variant === 'main' ? 'w-12 h-12' : 'w-10 h-10';
  const iconSize = variant === 'main' ? 'large' : 'medium';
  
  return (
    <div
      className={`${size} flex items-center justify-center rounded-full
        ${completed || active ? "bg-primary text-white" : "bg-gray-200 text-gray-500"}
      `}
    >
      {completed ? (
        <TaskAltRoundedIcon fontSize={iconSize} />
      ) : (
        React.cloneElement(icon, { fontSize: iconSize } as unknown as StepIconProps)
      )}
    </div>
  );
};
export default StepperIcon;